/** @format */
import { Icon, IconVariant } from '@mpb-com/feather/components/atoms/icon';
import React, { ForwardRefRenderFunction, Ref, forwardRef } from 'react';
import styled from 'styled-components';

import Arrow from '@toucan/client/global/icons/legacy/arrow-right.svg';

import { styles } from './navigation-button.styles';
import { NavigationButtonProps } from './types';

const StyledNavigationButton = styled(Icon)`
    ${styles}
`;

const NavigationButtonWithRef: ForwardRefRenderFunction<
    HTMLButtonElement,
    NavigationButtonProps
> = (
    {
        'data-testid': dataTestId = 'navigation-button',
        'aria-label': ariaLabel,
        onClick,
        className,
        direction,
        title,
        ...otherProps
    }: NavigationButtonProps,
    ref: Ref<HTMLButtonElement>
) => (
    <StyledNavigationButton
        ref={ref}
        onClick={onClick}
        className={className}
        data-testid={dataTestId}
        direction={direction}
        title={title}
        aria-label={ariaLabel}
        variant={IconVariant.ACTIONABLE_SECONDARY}
        {...otherProps}
    >
        <Arrow />
    </StyledNavigationButton>
);

export const NavigationButton = forwardRef(NavigationButtonWithRef);
